export default "__VITE_ASSET__Djn3AzgO__"